import React, { FC } from 'react';
import clsx from 'clsx';
import { MdSearch as SearchIcon } from '@react-icons/all-files/md/MdSearch';
import { InputBase } from '@material-ui/core';
import { createUseStyles } from 'src/theming';
import { RiCloseCircleLine as CrossIcon } from '@react-icons/all-files/ri/RiCloseCircleLine';

const useStyles = createUseStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    background: 'white',
    border: '1px solid #00000036',
    borderRadius: 4,
  },
  icon: {
    margin: 8,
  },
  emptyQuery: {},
  resetBttn: {
    color: 'rgba(0, 0, 0, 0.54)',
    cursor: 'pointer',
    marginRight: 7,
    transition: '250ms',
    '&$emptyQuery': {
      width: 0,
      overflow: 'hidden',
    },
  },
});

interface Props {
  className?: any;
  onChange: (searchString: string) => void;
  value?: string;
}

const SearchBar: FC<Props> = ({ className, value, onChange }) => {
  const classes = useStyles();

  const handleReset = () => {
    onChange('');
  };

  return (
    <div className={clsx(classes.root, className)}>
      <SearchIcon size={20} color='#0000008a' className={classes.icon} />
      <InputBase
        placeholder='Recherche ...'
        onChange={(event) => onChange(event.target.value as string)}
        value={value || ''}
        fullWidth
      />

      <CrossIcon
        size={20}
        className={clsx(classes.resetBttn, { [classes.emptyQuery]: !value || value.length <= 0 })}
        onClick={handleReset}
      />
    </div>
  );
};

export default SearchBar;
